<template>
  <v-dialog
    v-model="dialog"
    persistent
    :max-width="maxWidth"
  >
    <v-card>
      <v-card-title class="headline">
        <slot name="header" />
      </v-card-title>
      <v-card-text>
        <slot name="content" />
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1" />
        <v-btn
          color="primary"
          text
          @click="cancel"
          v-if="withCancelButton"
        >{{ $i18n.t("dialog.confirmation.close") }}</v-btn>
        <v-btn
          color="primary"
          text
          @click="confirm"
          v-if="withConfirmation"
        >OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: {
      required: true,
      type: Boolean
    },
    withConfirmation: {
      type: Boolean,
      default: false
    },
    withCancelButton: {
      type: Boolean,
      default: true
    },
    maxWidth: {
      required: false,
      type: String,
      default: '50%'
    }
  },
  methods: {
    confirm() {
      this.$emit('success');
    },
    cancel() {
      this.$emit('cancel');
    }
  },
  mounted() {}
};
</script>

<style>
.v-card__title > h1 {
  font-size: 24px !important;
}
</style>
